@if (flagShow) {
  <div class="loader" [ngStyle]="{'opacity':opacity}">
    @if (loaderShow) {
      <div class="spinner spinner-rainbow" >{{textMessage}}
        <div class="spinner-ring" aria-hidden="true" style="margin-top: 10px;"></div>
        <span class=" access"> <b>Loading...</b></span>
      </div>
    }
    <!-- <button (click)="getFlag()">Flag</button>   {{flagShow}} -->
  </div>
}
